const Dishes = [

  {id: 1, image: '/Assets/croissant.jpg', name: 'Croissant / Coffee', category: 'breakfast', price: '800', },

  {id: 2, image: '/Assets/eggs.jpg', name: 'Egg Bacon Sandwich', category: 'breakfast', price: '1, 100', },

  {id: 3, image: '/Assets/pancakes.jpg', name: 'Strawberry Pancakes', category: 'breakfast', price: '1, 050', },

  {id: 4, image: '/Assets/waffles.jpg', name: 'Blue Berry Waffles', category: 'breakfast', price: '1, 050', },

  {id: 5, image: '/Assets/kabab.jpg', name: 'Grilled Kabab', category: 'main course', price: '1, 500', },

  {id: 6, image: '/Assets/fish.jpg', name: 'Grilled Salmon Fish', category: 'main course', price: '1, 600', },

  {id: 7, image: '/Assets/pasta.jpg', name: 'Italian Pasta', category: 'main course', price: '1, 200', },

  {id: 8, image: '/Assets/wings.jpg', name: 'Chicked Wings', category: 'main course', price: '1, 200', },

  {id: 9, image: '/Assets/desert.jpg', name: 'Cherry Ice Cream', category: 'desert', price: '750', },

  {id: 10, image: '/Assets/cake.jpg', name: 'Black Forest Cake', category: 'desert', price: '150', },

  {id: 11, image: '/Assets/cheesecake.jpg', name: 'Blue Berry Cake', category: 'desert', price: '160', },

  {id: 12, image: '/Assets/smothy.jpg', name: 'Stawberry Smothie', category: 'desert', price: '250', },

  {id: 13, image: '/Assets/tusker.jpg', name: 'Tusker', category: 'drinks', price: '800', },

  {id: 14, image: '/Assets/red.jpg', name: 'Red label', category: 'drinks', price: '1000', },

  {id: 15, image: '/Assets/shakes.jpg', name: 'Fruity Milkshakes', category: 'drinks', price: '350', },

  {id: 16, image: '/Assets/cocktail.jpg', name: 'Cocktail', category: 'drinks', price: '400', },

  {id: 17, image: '/Assets/coffee.jpg', name: 'Cappuccino', category: 'coffee', price: '250', },

  {id: 18, image: '/Assets/latte.jpg', name: 'Latte', category: 'coffee', price: '280', },

  {id: 19, image: '/Assets/expresso.jpg', name: 'Expresso', category: 'coffee', price: '200', },

  {id: 20, image: '/Assets/macchiato.jpeg', name: 'Macchiato', category: 'coffee', price: '250', },

  {id: 21, image: '/Assets/iced_latte.jpg', name: 'Iced Latte', category: 'coffee', price: '250', },

];

export default Dishes;